export const SET_SERVICE = 'setService'
export const SET_SERVICES = 'setServices'
export const SET_CATEGORIES = 'setCategories'
export const SERVICE_RESET = 'setReset'
export const SERVICE_RESET_STATE = 'setResetState'